import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { IonicModule } from "@ionic/angular";
import { TranslateModule } from "@ngx-translate/core";
import { AssignEquipmentComponent } from "./assign-equipment.component";
import { SelectDropdownModule } from "../select-dropdown/select-dropdown.module";

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    IonicModule,
    TranslateModule,
    SelectDropdownModule,
  ],

  declarations: [AssignEquipmentComponent],
  exports: [AssignEquipmentComponent],
})
export class AssignEquipmentComponentModule {}
